import { render, staticRenderFns } from "./ActivityAddPage.vue?vue&type=template&id=05610980&scoped=true&"
import script from "./ActivityAddPage.vue?vue&type=script&lang=js&"
export * from "./ActivityAddPage.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAddPage.vue?vue&type=style&index=0&id=05610980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05610980",
  null
  
)

export default component.exports